import NewPastImages from './NewPastImages'

export default NewPastImages
